import { render } from "./NotFound.vue?vue&type=template&id=175bf7e6"
const script = {}
script.render = render

export default script